import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { SearchFilter } from 'core/components';

const TableFilterTemplate = function(props) {
    const {queryUtility, filterStore, t, children, showSearchFilter = true, showFilterButtons = true} = props;
    //const hideFilter = (!children || React.Children.count(children) === 0) || props.showClear;
    const clearVisible = (children != null || React.Children.count(children) > 0) || props.showClear;
    return (
        <React.Fragment>
            <div className='filter--table__wrap'>
                <div className='filter--table u-mar--bottom--sml'>
                    {
                        showSearchFilter
                        ?
                        <SearchFilter
                        className='input input--base input--search'
                        queryUtility={queryUtility}
                        clearVisible={clearVisible}
                        />
                        :
                        ''
                    }
                </div>
                {renderFilterToggleButton(filterStore, children, t)}
            </div>
            {renderFilter(filterStore, queryUtility, children, showFilterButtons, t)}
        </React.Fragment>
    );
};

TableFilterTemplate.propTypes = {
    queryUtility: PropTypes.object.isRequired,
    filterStore: PropTypes.object.isRequired,
    showClear: PropTypes.bool,
    t: PropTypes.any,
    children: PropTypes.any,
    showSearchFilter: PropTypes.any,
    showFilterButtons: PropTypes.any,
};

TableFilterTemplate.defaultProps = {
    showClear: false
};

function renderFilterToggleButton(filterStore, filters, t){
    if (!filters || React.Children.count(filters) === 0) return null;
    return(
        <button
                className='btn btn--base btn--link u-mar--left--auto u-mar--bottom--sml'
                onClick={filterStore.toggleFilterVisibility}>
                <span>{t('GRID.FILTERS_BUTTON')}</span>
                <span className='u-icon u-icon--tny u-icon--filter-dd' />
        </button>
    );
}

function renderFilter(filterStore, queryUtility, filters, showFilterButtons, t) {
    if (!filters || React.Children.count(filters) === 0) return null;
    return (
        <React.Fragment>
            
            {!filterStore.filterVisible ? null : (
                <div className="card--primary card--filter">
                    <div className="row row--form">
                        {filters}
                        {showFilterButtons &&
                            <div className="col col-sml-12 col-med-6 col-lrg-4 col-xxlrg-2 form__group hide--on-print u-mar--top--med">
                                <button
                                    className='btn btn--base btn--primary u-mar--right--tny'
                                    onClick={() => queryUtility.fetch()}
                                >
                                    <span>{t('GRID.FILTER.SEARCH_BUTTON')}</span>
                                </button>
                                <button
                                    className='btn btn--base btn--secondary'
                                    onClick={() => queryUtility.resetFilter()}
                                >
                                    {t('GRID.FILTER.CLEAR_BUTTON')}
                                </button>
                            </div>
                        }
                    </div>
                </div>
            )}
        </React.Fragment>
    );
}

export default defaultTemplate(TableFilterTemplate);
